var map = {
	"./appStore.svg": "74e4",
	"./arrow_smart.svg": "ab90",
	"./logo.svg": "a83d",
	"./pig_arrow.svg": "8fa6",
	"./playMarket.svg": "fa95",
	"./smart-security.svg": "0f16",
	"./sos.svg": "3064",
	"./transfer.svg": "528f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2294";